import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {GivebackComponent } from './giveback.component';
const routes: Routes = [
  { path: 'giveback',  component: GivebackComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GivebackRoutingModule { }
